import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { StyledCopyrightLink as A } from "components/Copyright/styled";

export const useGetCopyrights = () => {
  const { t } = useTranslation("common");

  return useMemo(
    () => [
      {
        names: ["2gis"],
        CopyrightComponent: (
          <>
            {t("copyright.basemapProvidedBy")}{" "}
            <A href={"http://law.2gis.ru/licensing-agreement"}>{t("copyright.2gis")}</A>
          </>
        ),
      },
      {
        names: ["osm", "osm_mono"],
        CopyrightComponent: (
          <>
            &copy; {t("copyright.contributors")} <A href={"http://www.openstreetmap.org/copyright"}>OpenStreetMap</A>
          </>
        ),
      },
      {
        names: ["stamen_terrain", "stamen_toner", "stamen_watercolor"],
        isDark: true,
        CopyrightComponent: (
          <>
            Map tiles by <A href="http://stamen.com">Stamen Design</A>, under{" "}
            <A href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</A>. Data by{" "}
            <A href="http://openstreetmap.org">OpenStreetMap</A>, under{" "}
            <A href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</A>.
          </>
        ),
      },
      {
        names: ["carto_dm"],
        isDark: true,
        CopyrightComponent: (
          <>
            Map tiles by <A href="https://cartodb.com/basemaps">CartoDB</A>, under{" "}
            <A href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</A>. Data by{" "}
            <A href="http://openstreetmap.org">OpenStreetMap</A>, under{" "}
            <A href="http://www.openstreetmap.org/copyright">ODbL</A>
          </>
        ),
      },
      {
        names: ["node_dencity", "node_density"],
        isDark: true,
        CopyrightComponent: (
          <>
            &copy; <A href="https://creativecommons.org/licenses/by/3.0">Martin Raifer</A>, data &copy;{" "}
            <A href="http://openstreetmap.org">OpenStreetMap</A> contributors
          </>
        ),
      },
    ],
    [t],
  );
};
